import { createFileRoute } from "@tanstack/react-router";
import type { SetOpsTestCase } from "geom/polyclip/test/setOpsTestCaseType";
import { circlePolygon, rectDonutPolygon } from "geom/polyclip/test/testCasesSetOps";
import styles from "lib/components/debug/polyclip.module.scss";
import { useEffect, useState } from "react";
import { SetOpsTestCaseCanvas } from "./set-ops-test";

function SetOpsTest() {
  const [renderResult, setRenderResult] = useState(true);
  const [renderSnapRoundResult, setRenderSnapRoundResult] = useState(true);
  const [renderPolygonClippingResult, setRenderPolygonClippingResult] = useState(true);

  return (
    <div className={styles.polyclip}>
      <div>
        <h4>Fuzz</h4>
        <FuzzSetOpsTestCase
          renderResult={renderResult}
          renderSnapRoundResult={renderSnapRoundResult}
          renderPolygonClippingResult={renderPolygonClippingResult}
        />
      </div>
      <div
        style={{
          top: 0,
          right: 0,
          zIndex: 3,
          background: "white",
          padding: 4,
          position: "fixed",
          overflowY: "scroll",
          overflowX: "hidden",
        }}
      >
        <h4>Result display</h4>
        <table>
          <thead>
            <tr>
              <td>Show</td>
              <td>Source</td>
              <td>Color</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <input type="checkbox" checked={renderResult} onChange={() => setRenderResult(!renderResult)} />
              </td>
              <td>Result</td>
              <td style={{ color: "red" }}>red</td>
            </tr>
            <tr>
              <td>
                <input
                  type="checkbox"
                  checked={renderSnapRoundResult}
                  onChange={() => setRenderSnapRoundResult(!renderSnapRoundResult)}
                />
              </td>
              <td>Result (Snap Round)</td>
              <td style={{ color: "blue" }}>blue</td>
            </tr>
            <tr>
              <td>
                <input
                  type="checkbox"
                  checked={renderPolygonClippingResult}
                  onChange={() => setRenderPolygonClippingResult(!renderPolygonClippingResult)}
                />
              </td>
              <td>Polygon-clipping</td>
              <td style={{ color: "green" }}>green</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

function FuzzSetOpsTestCase({
  renderResult,
  renderSnapRoundResult,
  renderPolygonClippingResult,
}: {
  renderResult: boolean;
  renderSnapRoundResult: boolean;
  renderPolygonClippingResult: boolean;
}) {
  const [fuzzing, setFuzzing] = useState<boolean>();
  const [fuzzSetOpsTestCase, setFuzzSetOpsTestCase] = useState<SetOpsTestCase | undefined>(undefined);

  useEffect(() => {
    if (!fuzzing) {
      return undefined;
    }

    function fuzzOnce() {
      setFuzzSetOpsTestCase({
        name: "Fuzz",
        polygons: [
          circlePolygon(100, 100, 100, Math.floor(Math.max(3, Math.random() * 10))),
          rectDonutPolygon(Math.floor(Math.max(3, Math.random() * 100)), 40, 160, 160, 20),
          rectDonutPolygon(
            Math.floor(Math.max(3, Math.random() * 100)),
            Math.floor(Math.max(3, Math.random() * 100)),
            160,
            160,
            20,
          ),
          circlePolygon(200, 200, 100, Math.floor(Math.max(3, Math.random() * 10))),
        ],
        op: "subtract",
        operands: [
          [0, 1],
          [2, 3],
        ],
      });
    }

    const interval = setInterval(fuzzOnce, 16);

    return () => {
      clearInterval(interval);
    };
  }, [fuzzing]);

  return (
    <>
      <div>
        <button onClick={() => setFuzzing(!fuzzing)}>Fuzz</button>
      </div>
      <div
        style={{
          display: "flex",
          fontWeight: "bold",
          flexWrap: "wrap",
          fontSize: 12,
        }}
      >
        {fuzzSetOpsTestCase && (
          <SetOpsTestCaseCanvas
            test={fuzzSetOpsTestCase}
            renderInput
            renderResult={renderResult}
            renderSnapRoundResult={renderSnapRoundResult}
            renderPolygonClippingResult={renderPolygonClippingResult}
          />
        )}
      </div>
    </>
  );
}

export const Route = createFileRoute("/debug/polyclip/set-ops-fuzz")({
  component: SetOpsTest,
});
